export interface WikiSummary {
  id: string;
  displayName: string;
  fileName: string;
  updatedAt: string;
  categoryId: string | null;
  categoryText: string | null;
}

const apiBase = () => process.env.REACT_APP_API_URL ?? "";

export async function fetchActiveWikis(authToken: string): Promise<WikiSummary[]> {
  const response = await fetch(`${apiBase()}/api/v1/wikis`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  if (!response.ok) throw new Error(`Failed to load wikis (${response.status})`);
  const body = await response.json();
  return body.wikis ?? [];
}

/** The download needs the bearer token, so it goes through fetch rather than a plain link. */
export async function downloadWiki(authToken: string, wiki: WikiSummary): Promise<void> {
  const response = await fetch(`${apiBase()}/api/v1/wikis/${wiki.id}/download`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  if (!response.ok) throw new Error(`Failed to download ${wiki.displayName} (${response.status})`);
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = wiki.fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
